import { Controller } from 'stimulus';
import * as basicLightbox from 'basiclightbox';
import Mustache from 'mustache';

const lightbox = {
  template: null,
  content: null,
  element: null
}

let currentElement = null;
let isKeyPressed = false;

export default class extends Controller {
  static targets = [
    'button',
    'template',
  ];

  /**
  * Automatically called when stimulus has initialized controller
  */
  initialize() {
    lightbox.template = this.templateTarget.innerHTML;
  }

  /**
   * Open lightbox
   * @param {object} el clicked button in page
   */
  open(el) {
    if (el.currentTarget) {
      el = el.currentTarget;
    }
    currentElement = el;
    // Lets check if open element has template in it
    if (el.querySelector('[data-target="lightbox.template"]')) {
      lightbox.template = el.querySelector('[data-target="lightbox.template"]').innerHTML;
    } else {
      lightbox.template = this.templateTarget.innerHTML;
    }
    this.getContent(el);
    lightbox.element = basicLightbox.create(lightbox.content);
    lightbox.element.show();
    //document.querySelector('.lightbox button').focus();
    this.listeners();
  }

  /**
   * Get content for lightbox
   * @param {object} el clicked button in page
   */
  getContent(el) {
    let options = {
      content: el.getAttribute('data-content'),
      caption: el.getAttribute('data-caption'),
      prev: el.previousSibling?.previousSibling?.classList.contains('js-lightbox-trigger') ? true : false,
      next: el.nextSibling?.nextSibling?.classList.contains('js-lightbox-trigger') ? true : false,
      type: el.getAttribute('data-type'),
    }
    if ( options.type === 'image') {
      options.content = '<img src="' + options.content + '" alt="">';
      this.setContent(options);
    } else {
      options.content = el.querySelector('.js-lightbox-content').innerHTML;
      this.setContent(options);
    }
  }

  /**
   * Set content to variable and use mustache
   * @param {object} options content, caption, prev, next
   */
  setContent(options) {
    lightbox.content = Mustache.render(lightbox.template, options);
  }

  /**
   * Add events to keyup and html elements
   */
  listeners() {
    const _this = this;

    document.addEventListener('keyup', (event) => {
      isKeyPressed = false;
    });

    document.addEventListener('keydown', (event) => {
      if (!isKeyPressed) {
        isKeyPressed = true;
        if (event.code === 'Escape') {
          lightbox.element.close();
        }
        if (event.code === 'ArrowLeft') {
          _this.prev();
        }
        if (event.code === 'ArrowRight') {
          _this.next();
        }
        isKeyPressed = true;
      }
    });

    document.querySelectorAll('.js-lightbox-close').forEach((button) => {
      button.addEventListener('click', () => {
        lightbox.element.close();
      });
    });

    document.querySelectorAll('.js-lightbox-prev').forEach((button) => {
      button.addEventListener('click', () => {
        this.prev();
      });
    });

    document.querySelectorAll('.js-lightbox-next').forEach((button) => {
      button.addEventListener('click', () => {
        this.next();
      });
    });
  }

  /**
   * Get previous lightbox element and open it
   */
  prev() {
    let prev = currentElement.previousSibling?.previousSibling?.classList.contains('js-lightbox-trigger') ? true : false;
    if (prev) {
      lightbox.element.close();
      this.open(currentElement.previousSibling?.previousSibling);
    }
    isKeyPressed = false;
  }

  /**
   * Get next lightbox element and open it
   */
  next() {
    let next = currentElement.nextSibling?.nextSibling?.classList.contains('js-lightbox-trigger') ? true : false;
    if (next) {
      lightbox.element.close();
      this.open(currentElement.nextSibling?.nextSibling);
    }
    isKeyPressed = false;
  }

  /**
   * Hubspot download form
   * @param {object} el clicked button in page
   */
  hubspotForm(el) {
    this.open(el);

    if (el.currentTarget) {
      el = el.currentTarget;
    }

    window.jQuery = window.jQuery || (() => ({
      // these are all methods required by HubSpot
      change: () => {},
      trigger: () => {},
    }));

    hbspt.forms.create({ // eslint-disable-line no-undef
      portalId: '6463692',
      formId: '58ba7194-62d7-4f28-a79a-172f453f131b',
      css: '',
      target: '.lightbox .js-hubspot-material',
      cssClass: '',
      locale: el.getAttribute('data-language'),
      onFormReady: function($form, ctx) {
        var contents = {
          latest_downloaded_material_name: el.getAttribute('data-materialname'),
          latest_downloaded_material_url: el.getAttribute('data-materialurl'),
          latest_downloaded_material_thumbnail: el.getAttribute('data-materialThumbnail'),
          latest_downloaded_material_type: el.getAttribute('data-materialType'),
        }

        for (var key in contents) {
          if (contents[key]) {
            var elems = document.getElementsByName(key);

            if (elems.length) {
              elems[0].setAttribute('value', contents[key]);
            }
          }
        }
      }
    });

  }
}
